import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import I18n from 'i18n-js';

import ModalConfirm from '../../../components/forms/ModalConfirm';

import * as selectors from '../../../../selectors/customer-po/current/cancelOrder';
import * as actions from '../../../../actions/customer-po/current/cancelOrder';
import {changeFilterText} from '../../../../actions/customer-po/current/showListOrders';
const DeleteOrderModal = props => (
  <ModalConfirm
    {...props}
    onConfirmClick={() => props.cancelOrder(props.id)}
  />
);

const mapStateToProps = state => ({
  isOpen: selectors.isOpen(state),
  title: I18n.t('PageOrder.CanceledStyle'),
  confirmMessage: I18n.t('PageOrder.ConfirmCanceled'),
  cancelLabel: I18n.t('Btn.CANCEL'),
  okLabel: I18n.t('Btn.YES'),
  id: selectors.getId(state),
});

const mapDispatchToProps = (dispatch) => ({
  onCloseClick() {
    dispatch(actions.hideModal())
  },

  cancelOrder(id) {
    dispatch(actions.cancelOrder(id));
    dispatch(changeFilterText(''));
  },
});

export default connect(mapStateToProps, mapDispatchToProps) (withRouter(DeleteOrderModal));
